




























import { Vue, Component, Prop } from "vue-property-decorator";
import ContractFormLearningResourceTableItem from "@/components/contract/ContractFormLearningResourceTableItem.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import { LearningResourceInfo as ILearningResourceInfo } from "@/api/models/learning-resource-info";

@Component({
  components: { CustomTable, ContractFormLearningResourceTableItem }
})
export default class ContractFormLearningResourceTable extends Vue {
  @Prop({ default: [] }) learningResources!: Array<ILearningResourceInfo>;
  @Prop({ default: false }) disableEdit!: boolean;

  removeResource(index: number) {
    this.$emit("removeLearningResource", index);
  }

  get fullPrice() {
    let fullPrice: number = 0;
    this.learningResources.forEach(el => (fullPrice += el.amount));
    return fullPrice;
  }
}
